// Fetches a KYC file for in-app preview. The request has to go through the patched
// window.fetch so the `accessToken` / `subdomain` headers are attached - a raw
// `<iframe src>` pointing at /files/kyc/view carries neither and always 401s.
export const viewKycFile = async (
  clientId: string,
  firmename: string,
  type: string,
  filename: string
): Promise<{ blob: Blob; contentType: string } | null> => {
  try {
    const params = new URLSearchParams({ clientId, firmename, type, filename })

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/files/kyc/view?${params.toString()}`,
      { method: 'GET' }
    )

    if (!response.ok) {
      console.error('File preview failed:', await response.text())
      return null
    }

    const contentType = response.headers.get('content-type') ?? 'application/octet-stream'
    return { blob: await response.blob(), contentType }
  } catch (error) {
    console.error('Unexpected file preview error:', error)
    return null
  }
}
